/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */

import Index from "./Index";
import ProtectIndex from "./protect/Index";
import ProtectWatchIndex from "./protectWatch/Index";
import PageAdd from "./PageAdd";
import PageEdit from "./PageEdit";
import DepartmentIndex from "./department/Index";
import DepartmentAdd from "./department/PageAdd";
import DepartmentEdit from "./department/PageEdit";
import DepartmentContact from "./department/PageContact";

const router = {
  path: "custom",
  breadcrumbName: "客户管理",
  childRoutes: [
    {
      path: "list",
      breadcrumbName: "客户列表",
      indexRoute: {
        component: Index,
      },
    },
    {
      path: "protect",
      breadcrumbName: "客户保护监控列表",
      indexRoute: {
        component: ProtectWatchIndex,
      },
    },
    {
      path: "department",
      breadcrumbName: "分属部门客户管理",
      indexRoute: {
        component: DepartmentIndex,
      },
      childRoutes: [
        {
          path: ":uuid/contact",
          breadcrumbName: "联系记录",
          component: DepartmentContact,
        },
        {
          path: "protect",
          breadcrumbName: "保护列表",
          component: ProtectIndex,
        },
        {
          path: "add",
          breadcrumbName: "客户添加",
          component: DepartmentAdd,
        },
        {
          path: ":uuid/edit",
          breadcrumbName: "客户添加",
          component: DepartmentEdit,
        },
      ],
    },
    {
      path: "add",
      breadcrumbName: "客户添加",
      indexRoute: {
        component: PageAdd,
      },
    },
    {
      path: "edit/:uuid",
      breadcrumbName: "客户修改",
      indexRoute: {
        component: PageEdit,
      },
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/crm/custom/router.js